import moment from 'moment';

// Converts a number into a dollar format i.e. 1234 => $12.34
Number.prototype.formatMoney = function () {
  return this ? `$${(this / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}` : '$0.00';
};

Number.prototype.abbreviate = function () {
  if (this < 1000) {
    return this;
  }
  const rounded = Math.round((this * 10) / 1000) / 10;
  return `${rounded}K`;
};

// Formats a Django date in YYYY-MM-DD format. Returns
// the original object if it is not a valid date
String.prototype.formatDate = function (date_format) {
  const date_style = date_format || 'MMM Do, YYYY';
  const moment_date = moment(this);
  if (moment_date.isValid()) {
    return moment_date.format(date_style);
  }
  return this;
};

String.prototype.formatDatetime = function (datetime_format) {
  const datetime_style = datetime_format || 'MMM Do, YYYY h:mma';
  const moment_date = moment(this);
  if (moment_date.isValid()) {
    return moment_date.format(datetime_style);
  }
  return this;
};

String.prototype.capitalize = function (all) {
  if (all) {
    return this.split(' ').map(e => e.capitalize()).join(' ');
  }
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.ellipsify = function (length) {
  return this.length >= length ? `${this.slice(0, length)}...` : this;
};
